export default "__VITE_ASSET__CuRdQcwA__"